export const en = {
  documentTools: {
    configure: "Configure tools",
    configurationMode: "Tool configuration",
    bottomTools: "Bottom tools",
    bottomToolsSpan: "Bottom tools span",
    bottomSpan: {
      main: "Main content only",
      left: "Main + left tools",
      right: "Main + right tools",
      full: "Full width",
    },
    done: "Done",
    cancel: "Cancel",
    addTab: "Add tab",
    removeTool: "Remove {{tool}}",
    addHere: "Add tool here",
    addAt: "Add tool to {{side}}, position {{position}}",
    chooseTool: "Choose a tool",
    searchTools: "Search tools",
    moveHint: "Choose a tool to add or move it here.",
    noTools: "No tools found.",
    placement: { left: "Left", right: "Right", bottom: "Bottom" },
  },
  accessibility: {
    close: "Close",
    clearInput: "Clear input",
    clearDate: "Clear date",
    openCalendar: "Open calendar",
    decreaseValue: "Decrease value",
    increaseValue: "Increase value",
    loading: "Loading",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    previousPage: "Go to previous page",
    nextPage: "Go to next page",
    toggleSidebar: "Toggle Sidebar",
    resizeSidebar: "Resize Sidebar",
    resizeOrToggleSidebar: "Resize or toggle Sidebar",
    dataGrid: "Data grid",
    gridOptions: "Grid options",
    groupedRecords: "Grouped records",
    records: "Records",
    grouped: "Grouped {{index, number}}",
    sorted: "Sorted {{sort}} {{index, number}}",
    resizeColumn: "Resize {{column}} column",
    columnOptions: "Column options {{column}}",
    expand: "Expand {{label}}",
    collapse: "Collapse {{label}}",
    edit: "Edit {{label}}",
    select: "Select {{label}}",
    remove: "Remove {{label}}",
    resizeTools: "Resize {{side}} tools",
  },
  calendar: {
    apply: "Apply",
    startDate: "Start date",
    endDate: "End date",
    previousMonth: "Previous month",
    nextMonth: "Next month",
  },
  datePicker: { selectDate: "Select date", selectDateRange: "Select date range" },
  dataGrid: {
    sortDirection: { asc: "asc", desc: "desc" },
    rowCount_one: "{{count, number}} row",
    rowCount_other: "{{count, number}} rows",
    expandGroup_one: "Expand {{label}}, {{count, number}} row",
    expandGroup_other: "Expand {{label}}, {{count, number}} rows",
    collapseGroup_one: "Collapse {{label}}, {{count, number}} row",
    collapseGroup_other: "Collapse {{label}}, {{count, number}} rows",
    noRecords: "No records found.",
    clearSort: "Clear sort",
    options: "Grid options",
    selectAllRows: "Select all rows",
    rowMoved: "{{item}} moved to position {{position}} of {{total}}",
    selectRow: "Select row {{index, number}}",
    loading: "Loading…",
    pageLoadFailed: "Could not load rows.",
    retryPage: "Retry loading rows",
    rowUnsaved: "Unsaved changes.",
    rowSaving: "Saving…",
    rowSaveFailed: "Not saved.",
    noOptions: "No options",
    empty: "Empty",
    checked: "Yes",
    unchecked: "No",
    groupTotal: "Total {{value}}",
    total: "Total",
    allRows: {
      loading: "Loading all rows… {{loaded, number}}",
      loadingOf: "Loading all rows… {{loaded, number}} of {{total, number}}",
      progress: "Loading all rows",
      tooLarge: "Too many rows to group or total (more than {{limit, number}}). Narrow the search.",
      failed: "Not all rows could be loaded.",
      loaded: "All rows loaded.",
      retry: "Retry",
      removeGrouping: "Remove grouping",
    },
    row: "row",
    rows: "rows",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
    clearGrouping: "Clear grouping",
    groupBy: "Group by {{column}}",
    ungroup: "Ungroup",
    moveLeft: "Move left",
    moveRight: "Move right",
    pinLeft: "Pin left",
    pinRight: "Pin right",
    unpin: "Unpin",
    flexible: "Flexible width",
    resetView: "Reset view",
    density: "Density",
    densityOptions: { compact: "Compact", normal: "Normal", comfortable: "Comfortable" },
    stickyGroupRows: "Sticky group rows",
    stickyGroupFooters: "Sticky group footers",
    description: "Choose which columns and grouped-row behavior are shown.",
    columns: "Columns",
    addAscending: "Add ascending to sorting",
    addDescending: "Add descending to sorting",
    moveSortEarlier: "Move sort earlier",
    moveSortLater: "Move sort later",
    ungroupColumn: "Ungroup column",
    groupColumn: "Group by this column",
    moveGroupEarlier: "Move group earlier",
    moveGroupLater: "Move group later",
    sticky: "Sticky",
    none: "None",
    start: "Start",
    end: "End",
    both: "Both",
    fillWidth: "Fill remaining width",
    aggregate: "Aggregate",
    aggregateFunctions: { sum: "Sum", avg: "Average", min: "Minimum", max: "Maximum", count: "Count" },
    groupDisclosure_one: "{{action}} {{label}}, {{count}} row",
    groupDisclosure_other: "{{action}} {{label}}, {{count}} rows",
  },
  propertyGrid: {
    properties: "Properties",
    property: "Property",
    value: "Value",
    nothingSelected: "Nothing selected",
    required: "required",
    chooseColor: "Choose colour",
    messages: {
      required: "Enter a value.",
      min: "Enter {{min}} or more.",
      max: "Enter {{max}} or less.",
      maxLength: "Use at most {{maxLength}} characters.",
      color: "Enter a colour as #rrggbb.",
    },
  },
  pagination: { next: "Next", previous: "Previous", navigation: "pagination" },
  sidebar: { search: "Search..." },
  theme: { label: "Theme", choose: "Choose theme", system: "System", light: "Light", dark: "Dark" },
  language: { label: "Language", english: "English", dutch: "Nederlands", changeFailed: "Could not change language." },
  breadcrumbs: { navigation: "breadcrumb", more: "More breadcrumbs" },
  account: {
    restoring: "Restoring account",
    account: "Account",
    signIn: "Sign in",
    signOut: "Sign out",
    authenticationRequired: "Authentication required",
    authenticationRequiredFor: "Authentication required for {{account}}",
    openMenu: "Open account menu",
  },
  login: {
    title: "Sign in",
    username: "User name",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Signing in…",
    invalidCredentials: "Invalid user name or password.",
    failed: "Sign in failed.",
    sessionExpired: { title: "Session expired", message: "Sign in again to continue. Your open work is kept." },
  },
  statusBadge: { completed: "Completed", warning: "Warning", info: "Info", alert: "Alert", pending: "Pending" },
  iconPicker: { choose: "Choose an icon", search: "Search icons", icons: "Icons", noMatch: "No icon matches." },
  toast: { notifications: "Notifications" },
  chat: { attach: "Attach" },
  common: {
    copy: "Copy",
    copied: "Copied",
    close: "Close",
    clearSelection: "Clear selection",
    moreActions: "More actions",
    remove: "Remove",
    noOptions: "No options",
  },
  lookup: {
    typeToSearch_one: "Type at least {{count}} character to search.",
    typeToSearch_other: "Type at least {{count}} characters to search.",
    localUnavailable:
      "Local search requires a complete dataset within the item limit. Use source filtering for larger datasets.",
    failed: "Could not load options.",
    retry: "Retry",
    loading: "Loading…",
    loadMore: "Load more",
    refineSearch: "Refine your search to see more results.",
  },
  toolbar: { moreTools: "More tools" },
  pageStack: { back: "Back" },
  appShell: { resizePanel: "Resize panel" },
  desktopWindow: {
    controls: "Window controls",
    minimize: "Minimize window",
    maximize: "Maximize window",
    restore: "Restore window",
    close: "Close window",
  },
  document: {
    addTab: "Add tab",
    closeTab: "Close tab",
    openInNewTab: "Open in new tab",
    resizeTools: "Resize {{side}} tools",
    workspace: "Open documents",
    opening: "Opening document…",
    couldNotOpen: "Could not open document",
    unauthorized: "You are not authorized to open this document.",
    signInRequired: "Sign in to open this document.",
    requestedFailed: "The requested document could not be opened.",
    retry: "Retry",
    returnToActive: "Return to active document",
    notFound: "Document not found",
    urlNotFound: "No document exists for this address.",
    failed: "This document stopped working",
    failedMessage: "An unexpected error occurred in this document. Your other documents are not affected.",
    sides: { left: "left", right: "right", top: "top", bottom: "bottom" },
  },
  item: {
    reorder: "Reorder {{item}}",
    moved: "{{item}} moved to position {{position}} of {{total}}",
  },
  slider: {
    value: "Value",
    indexedValue: "Value {{index, number}}",
    minimum: "Minimum value",
    maximum: "Maximum value",
  },
  dialog: {
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    alert: "Alert",
    input: "Input",
    value: "Value",
    yes: "Yes",
    no: "No",
    ok: "OK",
    error: "Error",
    message: "Message",
    warning: "Warning",
    unsavedChanges: {
      title: "Unsaved changes",
      message: "You have unsaved changes. Do you want to save them before you leave?",
      messageWithoutSave: "You have unsaved changes. They are lost when you leave.",
      save: "Save",
      discard: "Discard",
    },
  },
} as const
